import React, {  useEffect, useState } from 'react';
import { Link, useLoaderData } from 'react-router-dom';
import LoaderSmall from '../../Shared/LoderSmall/LoaderSmall';
import { AuthContext } from '../../../contexts/AuthProvider';
import { Datepicker } from 'flowbite-react';
import './AdminLead.css';

import DatePicker from "react-datepicker";
import toast from 'react-hot-toast';

const AdminLeadsDetails = () => {
  
  const [checkedItemsFive, setCheckedItemsFive] = useState([]);

    const postData = useLoaderData();
    console.log(postData);

    const [date, setDate] = useState(new Date());

    const handleCalendarClose = () => console.log("Calendar closed");
    const handleCalendarOpen = () => console.log("Calendar opened");
  
  
    console.log(date);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedCategory, setCategory] = useState(null);
    const [loading, setLoading] = useState(false);
    const [profileData, setProfileData] = useState([])
    // Loading state
    const [selectedLocation, setLocation] = useState(null);
    const [selectedAreaTwo, setAreaTwo] = useState(null);

    const [formData, setFormData] = useState({
        tittle: postData.tittle,
        gender: postData.gender,
        tutorGender: postData.tutorGender,
        numberOfStudents: postData.numberOfStudents,
        teachingDays: postData.teachingDays,
        TutoringTime: postData.TutoringTime,
        salary: postData.salary,
        required: postData.required,
        aboutUs: postData.aboutUs,
        AddressDetails: postData.AddressDetails,
        Institute: postData.Institute,
        requirement: postData.requirement,
        joiningDate: date.toString(),
    });

    const handleInputChange = (event) => {
      const { name, value } = event.target;
      setFormData(prevFormData => ({
          ...prevFormData,
          [name]: value
      }));
  };
  
  // ... other event handlers
  
    const [districts, setDistricts] = useState([]);
    const [Area, setArea] = useState([]);

    const fetchDistricts = async () => {
        try {
            const response = await fetch('https://tutor-tree-server-1.vercel.app/allDistrict');
            const data = await response.json();
            setDistricts(data);
        } catch (error) {
            console.error('Error fetching Districts:', error);
        }
    };

    useEffect(() => {
        fetchDistricts();
    }, []);

   ////////////////////////////////// khulna and chittagong area start ///////////////////////////////
   const [KhulnaArea, setKhulnaArea] = useState([]);
   const fetchKhulnaArea = async () => {
     try {
       const response = await fetch("https://tutor-tree-server-1.vercel.app/khulnaArea");
       const data = await response.json();
       setKhulnaArea(data);
     } catch (error) {
       console.error("Error fetching Districts:", error);
     }
   };
 
   useEffect(() => {
     fetchKhulnaArea();
   }, []);
   const [ChittagongArea, setChittagongArea] = useState([]);
   const fetchChittagongArea = async () => {
     try {
       const response = await fetch("https://tutor-tree-server-1.vercel.app/ChittagongArea");
       const data = await response.json();
       setChittagongArea(data);
     } catch (error) {
       console.error("Error fetching Districts:", error);
     }
   };
 
   useEffect(() => {
     fetchChittagongArea();
   }, []);

   const [DhakaArea, setDhakaArea] = useState([]);
   const fetchDhakaArea = async () => {
     try {
       const response = await fetch("https://tutor-tree-server-1.vercel.app/DhakaArea");
       const data = await response.json();
       setDhakaArea(data);
     } catch (error) {
       console.error("Error fetching Districts:", error);
     }
   };
 
   useEffect(() => {
      fetchDhakaArea();
   }, []);
   ////////////////////////////////// khulna and chittagong area end   ///////////////////////////////
 
    const fetchArea = async () => {
        try {
            const response = await fetch('https://tutor-tree-server-1.vercel.app/allArea');
            const data = await response.json();
            setArea(data);
        } catch (error) {
            console.error('Error fetching Districts:', error);
        }
    };

    useEffect(() => {
        fetchArea();
    }, []);



    console.log(profileData);
   
    const [isUploading, setIsUploading] = useState(false);
 
    const handleSubmit = () => {
      
        const jobId = postData.jobId

        const updatedFormData = {
          ...formData,
          jobId: jobId,
          joiningDate: date.toString(),
          requiredSubject1: checkedItemsFive[0] || "",
          requiredSubject2: checkedItemsFive[1] || "",
          requiredSubject3: checkedItemsFive[2] || "",
          requiredSubject4: checkedItemsFive[3] || "",
          requiredSubject5: checkedItemsFive[4] || "",
          ...(selectedLocation && { city: selectedLocation }),
          ...(selectedAreaTwo && { area: selectedAreaTwo }),
          ...(selectedCategory && { category: selectedCategory }),
          ...(selectedOption && { class: selectedOption })
        };
      
        // Set loading state to true
        setIsUploading(true);
       console.log("update Data", updatedFormData);
     
        fetch('https://tutor-tree-server-1.vercel.app/allTutorsLeads/updateDetails', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(updatedFormData)
        })
          .then(response => response.json())
          .then(data => {
            // Handle the response from the server
            console.log('Response from server:', data);
      
            // Show a success toast
            toast.success('Uploaded successfully!');
          })
          .catch(error => {
            console.error('Error sending POST request:', error);
          })
          .finally(() => {
            // Set loading state to false after the request is completed
            setIsUploading(false);
          });
    };
    
    const classMapping = {
      'Pre-Schooling': 'Pre-Schooling',
      'Play': 'Play',
      'Nursery': 'Nursery',
      'KG': 'KG',
      'BM1': 'Class 1',
      'BM2': 'Class 2',
      'BM3': 'Class 3',
      'BM4': 'Class 4',
      'BM5': 'Class 5',
      'BM6': 'Class 6',
      'BM7': 'Class 7',
      'BM8': 'Class 8',
      'BM9': 'Class 9',
      'BM10': 'Class 10',
      'BMHSC-1stYear': 'HSC-1st Year',
      'BMHSC-2stYear': 'HSC-2nd Year',
      'EV1': 'Class 1',
      'EV2': 'Class 2',
      'EV3': 'Class 3',
      'EV4': 'Class 4',
      'EV5': 'Class 5',
      'EV6': 'Class 6',
      'EV7': 'Class 7',
      'EV8': 'Class 8',
      'EV9': 'Class 9',
      'EV10': 'Class 10',
      'EVHSC-1stYear': 'HSC-1st Year',
      'EVHSC-2stYear': 'HSC-2nd Year',
      'EM1': 'Class 1',
      'EM2': 'Class 2',
      'EM3': 'Class 3',
      'EM4': 'Class 4',
      'EM5': 'Class 5',
      'EM6': 'Class 6',
      'EM7': 'Class 7',
      'EM8': 'Class 8',
      'EM9': 'Class 9',
      'OLevel': 'OLevel',
      'ALevelAS': 'A Level (AS)',
      'ALevelA2': 'A Level (A2)',
      'EMHSC-2stYear': 'HSC-2nd Year',
      'Alim1': 'Class 1',
      'Alim2': 'Class 2',
      'Alim3': 'Class 3',
      'Alim4': 'Class 4',
      'Alim5': 'Class 5',
      'Alim6': 'Class 6',
      'Alim7': 'Class 7',
      'Alim8': 'Class 8',
      'Alim9': 'Class 9',
      'Alim10': 'Class 10',
      'Alim-1stYear': 'Alim-1st Year',
      'Alim-2stYear': 'Alim-2nd Year',
      'IslamicStudies': 'Islamic Studies',
      'HinduismStudies': 'Hinduism Studies',
      'BuddhismStudies': 'Buddhism Studies',
      'ChristianityStudies': 'Christianity Studies',
      'SchoolAdmissionTest': 'School Admission Test',
      'PublicUniversityAdmissionTest': 'Public University Admission Test',
      'PrivateUniversityAdmissionTest': 'Private University Admission Test',
      'MedicalCollegeAdmissionTest': 'Medical College Admission Test',
      'EngineeringUniversityAdmissionTest': 'Engineering University Admission Test',
      'Arts': 'Arts',
      'Music': 'Music',
      'InstrumentalMusic': 'Instrumental Music',
      'Dance': 'Dance',
      'Crafting': 'Crafting',
      'Recitation': 'Recitation',
      'TestPreparation': 'Test Preparation',
      'IELTS': 'IELTS',
      'TOEFL': 'TOEFL',
      'GRE': 'GRE',
      'GMAT': 'GMAT',
      'SAT': 'SAT',
      'GED': 'GED',
    };

    const subjects = [
      "All",
      "Bangla", 
      "English", 
      "Biology", 
      "Physics", 
      "Chemistry", 
      "Higher Math", 
      "ICT", 
      "Business Studies", 
      "Business Administration", 
      "Accounting", 
      "Finance", 
      "Home Economics", 
      "Management", 
      "Marketing", 
      "Finance and Banking", 
      "Economics", 
      "Civics", 
      "Geography", 
      "Psychology", 
      "Religious Studies", 
      "Statistics", 
      "Sociology", 
      "Commercial Geography", 
      "Production Management and Marketing", 
      "Agricultural Education", 
      "Logic", 
      "Social Work", 
      "Islamic History and Culture", 
      "History", 
      "Political Science", 
      "Engineering Drawing", 
      "Maths", 
      "General Science", 
      "Business Entrepreneurship", 
      "Electrical and Electronic Engineering", 
      "Physical Education, Health & Sports", 
      "Bangladesh & Global Studies", 
      "Social Science", 
      "Drawing", 
      "Arts and craft",
      "Bangladesh Studies",
      "English Literature",
      "Others"
  ];
    const handleChangeFive = (event) => {
      const label = event.target.nextSibling.htmlFor;
      if (event.target.checked) {
        // Add the label to the state if checked
        setCheckedItemsFive((prevItems) => [...prevItems, label]);
      } else {
        // Remove the label from the state if unchecked
        setCheckedItemsFive((prevItems) =>
          prevItems.filter((item) => item !== label)
        );
      }
    };
  
    const handleRemoveFive = (itemToRemove) => {
      setCheckedItemsFive((prevItems) =>
        prevItems.filter((item) => item !== itemToRemove)
      );
      // Uncheck the checkbox
      const checkbox = document.getElementById(itemToRemove);
      if (checkbox) {
        checkbox.checked = false;
      }
    };
  
    const formattedOutputFive = checkedItemsFive.map((item) => (
      <div
        className="flex flex-row justify-between pl-2 items-center m-2 bg-orange-100 h-7  rounded-3xl"
        key={item}
      >
        {item}
        <button
          onClick={() => handleRemoveFive(item)}
          className="w-7 h-7 ml-1 bg-orange-500 hover:bg-orange-600 text-white flex justify-center items-center rounded-full"
        >
          X
        </button>
      </div>
    ));

    return (
      <div className='border-2 border-gray-100 rounded-lg m-5'>
      <div className='w-full h-20 flex justify-left items-center border-b-2 border-gray-200 px-5'>
         <div>
             <div><h1 className='tittleMainLeadsDetails'>{postData.tittle}</h1></div>
             <div className='flex flex-row items-center '>
                 <div><h1 className='MainLeadsDetailsPera'>Job Id : {postData.jobId}</h1></div>
                 <div className='ml-3'>|</div>
                 <div className='ml-3'><h1 className='MainLeadsDetailsPera'>Posted Date : {new Date(postData.postedDate).toLocaleDateString("en-GB")}</h1></div>
             
             </div>
         </div>
        
      </div>
      <div className='px-5 mt-5'>
           <h1 className='MainLeadsDetailsPera'>Name : {postData.posterName} {postData.name}</h1>
           <h1 className='MainLeadsDetailsPera'>Email : {postData.email}</h1>
           <h1 className='MainLeadsDetailsPera'>Number : {postData.posterPhone}</h1>
      </div>
      <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-5 px-5 mt-5">
      <div className="">
    <div className="translate-y-3 ml-5 bg-white w-24 flex justify-center items-center textMain">
      Select City
    </div>

    <select
      required
      // name="district"
      // value={selectedLocation}
      // onChange={handleInputChange}
      onChange={(e) => setLocation(e.target.value)}
      className="h-[60px] select border-2 border-orange-500 select-error w-full "
    >
      <option disabled selected>
        {postData.city}
      </option>
      {districts.map((district, index) => (
        <option key={index} value={district.district}>
          {district.district}
        </option>
      ))}
    </select>
  </div>
  <div className="">
    {selectedLocation === "Chittagong" && (
      <div>
        <div className="translate-y-3 ml-5 bg-white w-28 flex justify-center items-center textMain">
         Select Area
        </div>
        <select
          // name="city"
          // value={selectedAreaTwo}
          className="h-[60px] select border-2 border-orange-500 select-error w-full"
          onChange={(e) => setAreaTwo(e.target.value)}
        >
      <option disabled selected>
        {postData.area}
      </option>
        {ChittagongArea.map((area, index) => (
        <option key={index} value={area.area}>
          {area.area}
        </option>
      ))}
        </select>
      </div>
    )}
      {selectedLocation === "Khulna" && (
      <div>
       <div className="translate-y-3 ml-5 bg-white w-28 flex justify-center items-center textMain">
         Select Area 
        </div>
        <select
          // name="area"
          // value={selectedAreaTwo}
          className="h-[60px] select border-2 border-orange-500 select-error w-full"
          onChange={(e) => setAreaTwo(e.target.value)}
        >
           <option disabled selected>
        {postData.area}
      </option>
        {KhulnaArea.map((area, index) => (
        <option key={index} value={area.area}>
          {area.area}
        </option>
      ))}
        </select>
      </div>
    )}
      {selectedLocation === "Dhaka" && (
      <div>
       <div className="translate-y-3 ml-5 bg-white w-28 flex justify-center items-center textMain">
         Select Area
        </div>
        <select
          // name="area"
          // value={selectedAreaTwo}
          className="h-[60px] select border-2 border-orange-500 select-error w-full"
          onChange={(e) => setAreaTwo(e.target.value)}
        >
           <option disabled selected>
        {postData.area}
      </option>
        {DhakaArea.map((area, index) => (
        <option key={index} value={area.area}>
          {area.area}
        </option>
      ))}
        </select>
      </div>
    )}
  </div>
  <div>
    <div className="translate-y-3 ml-5 bg-white w-48 flex justify-center items-center textMain">
      Tutor Gender Preference
    </div>

    <select
      required
      name="tutorGender"
      onChange={handleInputChange}
      className="h-[60px] select border-2 border-orange-500 select-error w-full "
    >
      <option disabled selected>
        {postData.tutorGender}
      </option>
      <option value="male">Male</option>
      <option value="female">Female</option>
      <option value="others">Any</option>
    </select>
  </div>
  <div>
    <div className="translate-y-3 ml-5 bg-white w-28 flex justify-center items-center textMain">
      Days / Week
    </div>

    <select
      required
      name="teachingDays"
      onChange={handleInputChange}
      className="h-[60px] select border-2 border-orange-500 select-error w-full "
    >
      <option disabled selected>
        {postData.teachingDays}
      </option>

      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="6">6</option>
      <option value="7">7</option>
      <option value="8">8</option>
      <option value="9">9</option>
      <option value="10">10</option>
    </select>
  </div>
  <div>
    <div className="translate-y-3 ml-5 bg-white w-40 flex justify-center items-center textMain">
      Number of Students
    </div>

    <select
      required
      name="numberOfStudents"
      onChange={handleInputChange}
      className="h-[60px] select border-2 border-orange-500 select-error w-full "
    >
      <option disabled selected>
        Select number of students
      </option>
      <option disabled selected>
        {postData.numberOfStudents}
      </option>

      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="6">6</option>
      <option value="7">7</option>
      <option value="8">8</option>
      <option value="9">9</option>
      <option value="10">10</option>
    </select>
  </div>
  <div>
          <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
            Tutoring Time
          </div>

          <select
            required
            name="TutoringTime"
            onChange={handleInputChange}
            className="h-[60px] select border-2 border-orange-500 select-error w-full "
          >
             <option disabled selected>
              Select Tutoring Time
            </option>
            <option value="7AM">7AM</option>
            <option value="8AM">8AM</option>
            <option value="10AM">10AM</option>
            <option value="11AM">11AM</option>
            <option value="12AM">12AM</option>
            <option value="2PM">2PM</option>
            <option value="3PM">3PM</option>
            <option value="4PM">4PM</option>
            <option value="4.30PM">4.30PM</option>
            <option value="5PM">5PM</option>
            <option value="5.30PM">5.30PM</option>
            <option value="6PM">6PM</option>
            <option value="6.30PM">6.30PM</option>
            <option value="7PM">7PM</option>
            <option value="7.30PM">7.30PM</option>
            <option value="8PM">8PM</option>
            <option value="9PM">9PM</option>
            <option value="Negotiable">Negotiable</option>
          </select>
        </div> 
  <div>
    <div className="translate-y-3 ml-5 bg-white w-20 flex justify-center items-center textMain">
      Category
    </div>

    <select
      
      
      className="h-[60px] select border-2 border-orange-500 select-error w-full "
      onChange={(e) => setCategory(e.target.value)}
    >
      <option disabled selected>
      {postData.category}
      </option>
      <option value="BanglaVersion">Bangla Version</option>
      <option value="EnglishVersion">English Version</option>
      <option value="EnglishMedium">English Medium </option>
      <option value="MadrasaMedium">Madrasa Medium</option>
      <option value="ReligiousStudies">Religious Studies</option>
      <option value="AdmissionTest">Admission Test</option>
      <option value="Arts">Arts</option>
      <option value="TestPreparation">Test Preparation </option>

      {/* Add more options as needed */}
    </select>
  </div>
  <div>
    {selectedCategory === "BanglaVersion" && (
      <div>
        <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
          Class
        </div>
        <select
        
          className="h-[60px] select border-2 border-orange-500 select-error w-full"
          onChange={(e) => setSelectedOption(e.target.value)}
        > <option disabled selected>{classMapping[postData.class] || postData.class}</option>
          <option value="Pre-Schooling">Pre-Schooling</option>
          <option value="Play">Play</option>
          <option value="Nursery">Nursery</option>
          <option value="KG">KG</option>
          <option value="BM1">Class 1</option>
          <option value="BM2">Class 2</option>
          <option value="BM3">Class 3</option>
          <option value="BM4">Class 4</option>
          <option value="BM5">Class 5</option>
          <option value="BM6">Class 6</option>
          <option value="BM7">Class 7</option>
          <option value="BM8">Class 8</option>
          <option value="BM9">Class 9</option>
          <option value="BM10">Class 10</option>
          <option value="BMHSC-1stYear">HSC-1st Year</option>
          <option value="BMHSC-2ndYear">HSC-2nd Year</option>
        </select>
      </div>
    )}

    {selectedCategory === "EnglishVersion" && (
      <div>
        <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
          Class
        </div>
        <select
         
          className="h-[60px] select border-2 border-orange-500 select-error w-full"
          onChange={(e) => setSelectedOption(e.target.value)}
        >
      <option disabled selected>
      {classMapping[postData.class] || postData.class}
      </option>
          <option disabled selected>{classMapping[postData.class] || postData.class}</option>
          <option value="Pre-Schooling">Pre-Schooling</option>
          <option value="Play">Play</option>
          <option value="Nursery">Nursery</option>
          <option value="KG">KG</option>
          <option value="EV2">Class 1</option>
          <option value="EV2">Class 2</option>
          <option value="EV3">Class 3</option>
          <option value="EV4">Class 4</option>
          <option value="EV5">Class 5</option>
          <option value="EV6">Class 6</option>
          <option value="EV7">Class 7</option>
          <option value="EV8">Class 8</option>
          <option value="EV9">Class 9</option>
          <option value="EV10">Class 10</option>
          <option value="EVHSC-1stYear">HSC-1st Year</option>
          <option value="EVHSC-2ndYear">HSC-2nd Year</option>
        </select>
      </div>
    )}
    {selectedCategory === "EnglishMedium" && (
      <div>
        <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
          Class
        </div>
        <select
          className="h-[60px] select border-2 border-orange-500 select-error w-full"
          onChange={(e) => setSelectedOption(e.target.value)}
        >
      <option disabled selected>
      {classMapping[postData.class] || postData.class}
      </option>
          <option value="Pre-Schooling">Pre-Schooling</option>
          <option value="Play">Play</option>
          <option value="Nursery">Nursery</option>
          <option value="KG">KG</option>
          <option value="EM1">Standard 1</option>
          <option value="EM2">Standard 2</option>
          <option value="EM3">Standard 3</option>
          <option value="EM4">Standard 4</option>
          <option value="EM5">Standard 5</option>
          <option value="EM6">Standard 6</option>
          <option value="EM7">Standard 7</option>
          <option value="EM8">Standard 8</option>
          <option value="EM9">Standard 9</option>
          <option value="OLevel">O Level</option>
          <option value="ALevelAS">A Level (AS)</option>
          <option value="ALevelA2">A Level (A2)</option>
        </select>
      </div>
    )}
    {selectedCategory === "MadrasaMedium" && (
      <div>
        <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
          Class
        </div>
        <select
          
          className="h-[60px] select border-2 border-orange-500 select-error w-full"
          onChange={(e) => setSelectedOption(e.target.value)}
        >
        <option disabled selected>
        {classMapping[postData.class] || postData.class}
      </option>
          <option value="Play">Play</option>
          <option value="Nursery">Nursery</option>
          <option value="KG">KG</option>
          <option value="Alim1">Class 1</option>
          <option value="Alim2">Class 2</option>
          <option value="Alim3">Class 3</option>
          <option value="Alim4">Class 4</option>
          <option value="Alim5">Class 5</option>
          <option value="Alim6">Class 6</option>
          <option value="Alim7">Class 7</option>
          <option value="Alim8">Class 8</option>
          <option value="Alim9">Class 9</option>
          <option value="OLevel">O Level</option>
          <option value="Alim-1stYear">Class-1st Year</option>
          <option value="Alim-2stYear">Class-2st Year</option>
        </select>
      </div>
    )}
    {selectedCategory === "ReligiousStudies" && (
      <div>
        <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
          Class
        </div>
        <select
          
          className="h-[60px] select border-2 border-orange-500 select-error w-full"
          onChange={(e) => setSelectedOption(e.target.value)}
        >
          <option disabled selected>
        {classMapping[postData.class] || postData.class}
      </option>
          <option value="IslamicStudies">Islamic Studies</option>
          <option value="HinduismStudies">Hinduism Studies</option>
          <option value="BuddhismStudies">Buddhism Studies</option>
          <option value="ChristianityStudies">
            Christianity Studies
          </option>
        </select>
      </div>
    )}
    {selectedCategory === "AdmissionTest" && (
      <div>
        <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
          Class
        </div>
        <select
          className="h-[60px] select border-2 border-orange-500 select-error w-full"
          onChange={(e) => setSelectedOption(e.target.value)}
        >
          <option disabled selected>
        {classMapping[postData.class] || postData.class}
      </option>
          <option value="SchoolAdmissionTest">
            School Admission Test
          </option>
          <option value="PublicUniversityAdmissionTest">
            Public University Admission Test
          </option>
          <option value="PrivateUniversityAdmissionTest">
            Private University Admission Test
          </option>
          <option value="MedicalCollegeAdmissionTest">
            Medical College Admission Test
          </option>
          <option value="EngineeringUniversityAdmissionTest">
            Engineering University Admission Test
          </option>
        </select>
      </div>
    )}
    {selectedCategory === "Arts" && (
      <div>
        <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
          Class
        </div>
        <select
        
          className="h-[60px] select border-2 border-orange-500 select-error w-full"
          onChange={(e) => setSelectedOption(e.target.value)}
        >
          <option disabled selected>
        {classMapping[postData.class] || postData.class}
      </option>
          <option value="DrawingAndPainting">Drawing and painting</option>
          <option value="Handwriting">Handwriting</option>
          <option value="Music">Music</option>
          <option value="InstrumentalMusic">Instrumental Music</option>
          <option value="Dance">Dance</option>
          <option value="Crafting">Crafting</option>
          <option value="Recitation">Recitation</option>
        </select>
      </div>
    )}
    {selectedCategory === "TestPreparation" && (
      <div>
        <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
          Class
        </div>
        <select
          
          className="h-[60px] select border-2 border-orange-500 select-error w-full"
          onChange={(e) => setSelectedOption(e.target.value)}
        >
          <option disabled selected>
        {classMapping[postData.class] || postData.class}
      </option>
          <option value="IELTS">IELTS</option>
          <option value="TOEFL">TOEFL</option>
          <option value="GMAT">GMAT</option>
          <option value="GRE">GRE</option>
          <option value="SAT">SAT</option>
          <option value="GED">GED</option>
          <option value="BankJobPreparation">Bank Job Preparation</option>
        </select>
      </div>
    )}
  </div>
  <div>
    <div className="translate-y-3 ml-5 bg-white w-24 flex justify-center items-center textMain">
      Hire Date
    </div>

    <div className="w-full h-[60px] border-2 border-orange-500 rounded-lg  justify-between inline-flex bg-white ">
      <div className="flex justify-center items-center">
      <DatePicker
          required
          selected={date}
          onChange={(date) => setDate(date)}
          onCalendarClose={handleCalendarClose}
          onCalendarOpen={handleCalendarOpen}
          className="calenderMjrTwo"
          dateFormat="dd/MM/yyyy"
          placeholderText="dd/mm/yyyy"
        />
      </div>
      <div className="flex justify-center items-center mr-3">
         <h1 className='px-3'>{new Date(postData.joiningDate).toLocaleDateString("en-GB")}</h1>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
        >
          <path
            d="M8.71094 0.78125H7.8125V0.3125C7.8125 0.139922 7.6726 0 7.5 0C7.3274 0 7.1875 0.139922 7.1875 0.3125V0.78125H2.8125V0.3125C2.8125 0.139922 2.6726 0 2.5 0C2.3274 0 2.1875 0.139922 2.1875 0.3125V0.78125H1.28906C0.578262 0.78125 0 1.35951 0 2.07031V8.71094C0 9.42174 0.578262 10 1.28906 10H8.71094C9.42174 10 10 9.42174 10 8.71094V2.07031C10 1.35951 9.42174 0.78125 8.71094 0.78125ZM9.375 8.71094C9.375 9.07769 9.07769 9.375 8.71094 9.375H1.28906C0.922305 9.375 0.625 9.07769 0.625 8.71094V3.53516C0.625 3.48123 0.66873 3.4375 0.722656 3.4375H9.27734C9.33127 3.4375 9.375 3.48123 9.375 3.53516V8.71094Z"
            fill="#FE7702"
          />
        </svg>
      </div>
    </div>
  </div>
  <div>
    <div className="translate-y-3 ml-5 bg-white w-24 flex justify-center items-center ">
      <h1 className="textMain">Salary(BDT)</h1>
    </div>
    <input
      required
      type="number"
      name="salary"
      placeholder={postData.salary}
      className="input border-2 border-orange-500 h-[60px] input-warning w-full "
      onChange={handleInputChange}
    />
  </div>
  <div className='relative'>
        <div className="translate-y-3 top-0 z-10 absolute ml-5 bg-white w-32 flex justify-center items-center textMain">
             Required Subject
        </div>
        <details className="dropdown w-full mt-5">
           <summary className="w-full selectTextMain cursor-pointer flex overflow-y-scroll justify-between px-4 items-center h-16 bg-white border-2 border-orange-500 hover:border-orange-500 rounded-lg hover:bg-white text-black">
             {checkedItemsFive.length > 0 ? (
               formattedOutputFive
             ) : (
              <h1 className="selectTextMain">{postData.requiredSubject1} {postData.requiredSubject2 ? "," : "" } {postData.requiredSubject2} {postData.requiredSubject3 ? "," : "" } {postData.requiredSubject3} {postData.requiredSubject4 ? "," : "" } {postData.requiredSubject4} {postData.requiredSubject5 ? "," : "" } {postData.requiredSubject5}</h1>
             )}
             <svg
               id="Layer_1"
               enable-background="new 0 0 128 128"
               height="20"
               viewBox="0 0 128 128"
               width="20"
               xmlns="http://www.w3.org/2000/svg"
             >
               <path
                 id="Down_Arrow_3_"
                 d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
               />
             </svg>
           </summary>
           <ul className="p-2 shadow menu dropdown-content z-[1] h-56 overflow-auto bg-base-100 rounded-box w-full">
             {
               subjects.map(subject=>
                 <div className="form-checkbox">
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id={subject}
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeFive}
                   />
                   <label className="ml-4 selectTextMain" htmlFor={subject}>
                   {subject}
                   </label>
                 </div>
               </div>  
               )
             }
           </ul>
        </details>
        </div>
  <div>
          <div className="translate-y-3 ml-5 bg-white w-56 flex justify-center items-center textMain">
          How did you hear about us?
          </div>

          <select
            required
            name="aboutUs"
            onChange={handleInputChange}
            className="h-[60px] select border-2 border-orange-500 select-error w-full "
          >
            <option disabled selected>
             {postData.aboutUs}
            </option>
            <option value="Facebook">Facebook</option>
            <option value="Friends & Family">Friends & Family</option>
            <option value="Banner/Poster">Banner/Poster</option>
            <option value="YouTube">YouTube</option>
            <option value="Google Search">Google Search</option>
          
          </select>
        </div>
  
  <div>
    <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
      Student Gender
    </div>

    <select
      required
      name="gender"
      onChange={handleInputChange}
      className="h-[60px] select border-2 border-orange-500 select-error w-full "
    >
      <option disabled selected>
        {postData.gender}
      </option>
      <option value="male">Male</option>
      <option value="female">Female</option>
    </select>
  </div>

  <div>
    <div className="translate-y-3 ml-5 bg-white w-20 flex justify-center items-center textMain">
      Institute
    </div>
    <input
      required
      type="text"
      name="Institute"
      placeholder={postData.Institute}
      className="input border-2 border-orange-500 h-[60px] input-warning w-full "
      onChange={handleInputChange}
    />
  </div>
  <div>
    <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
      Address Details
    </div>
    <input
      required
      type="text"
      name="AddressDetails"
      placeholder={postData.AddressDetails}
      className="input border-2 border-orange-500 h-[60px] input-warning w-full "
      onChange={handleInputChange}
    />
  </div>
  <div>
          <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
          Admin Reminder

          </div>
          <input
            type="text"
            name="additionInfo"
            placeholder={postData.additionInfo}
            className="input border-2 border-orange-500 h-[60px] input-warning w-full "
            onChange={handleInputChange}
          />
        </div>
  {/* <div>
    <div className="translate-y-3 ml-5 bg-white w-24 flex justify-center items-center textMain">
    Institute
    </div>

    <select
      required
      name="Institute"
      onChange={handleInputChange}
      className="h-[60px] select border-2 border-orange-500 select-error w-full "
    >
      <option disabled selected>
        {postData.Institute}
      </option>
      <option value="University Of Dhaka">University of Dhaka</option>
      <option value="BRAC University">BRAC University</option>
      <option value="Bangladesh University Of Engineering And Technology">Bangladesh University of Engineering and Technology</option>
      <option value="Rajshahi University">Rajshahi University</option>
      <option value="National University Bangladesh">National University, Bangladesh</option>
      <option value="North South University">North South University</option>
      <option value="Daffodil International University">Daffodil International University</option>
      <option value="American International University-Bangladesh">American International University-Bangladesh</option>
      <option value="University Of Chittagong">University of Chittagong</option>
      <option value="Shahjalal University of Science And Technology">Shahjalal University of Science and Technology</option>
      <option value="Independent University Bangladesh">Independent University, Bangladesh</option>
      <option value="Independent University Bangladesh">Independent University, Bangladesh</option>
      <option value="Ahsanullah University of Science And Technology">Ahsanullah University of Science and Technology</option>
      <option value="Bangladesh Agricultural University">Bangladesh Agricultural University</option>
      <option value="EastWest University">East West University</option>
      <option value="Jahangirnagar University">Jahangirnagar University</option>
      <option value="UnitedInternational University">United International University</option>
      <option value="Asian University for Women">Asian University for Women</option>
      <option value="Islamic University of Technology">Islamic University of Technology</option>
      <option value="International Islamic University, Chittagong">International Islamic University, Chittagong</option>
      <option value="Bangabandhu Sheikh Mujib Medical University">Bangabandhu Sheikh Mujib Medical University</option>
      <option value="Khulna University of Engineering and Technology">Khulna University of Engineering and Technology</option>
      <option value="Bangladesh University of Professionals">Bangladesh University of Professionals</option>
      <option value="Stamford University Bangladesh">Stamford University Bangladesh</option>
      <option value="University of Liberal Arts Bangladesh">University of Liberal Arts Bangladesh</option>
      <option value="Khulna University">Khulna University</option>
      <option value="University of Asia Pacific">University of Asia Pacific</option>
      <option value="International University of Business Agriculture and Technology">2International University of Business Agriculture and Technology</option>
      <option value="Southeast University, Bangladesh">Southeast University, Bangladesh</option>
      <option value="Jagannath University">Jagannath University</option>
      <option value="Bangladesh University of Textiles">Bangladesh University of Textiles</option>
      <option value="Islamic University">Islamic University</option>
      <option value="Bangabandhu Sheikh Mujibur Rahman Agricultural University">Bangabandhu Sheikh Mujibur Rahman Agricultural University</option>
      <option value="Chittagong University of Engineering and Technology">Chittagong University of Engineering and Technology</option>
      <option value="University of Barisal">University of Barisal</option>
      <option value="Bangladesh University of Business and Technology">Bangladesh University of Business and Technology</option>
      <option value="Chittagong Veterinary and Animal Sciences University">Chittagong Veterinary and Animal Sciences University</option>
      <option value="Rajshahi University of Engineering and Technology">Rajshahi University of Engineering and Technology</option>
      <option value="Noakhali Science and Technology University">Noakhali Science and Technology University</option>
      <option value="Dhaka University of Engineering and Technology">Dhaka University of Engineering and Technology</option>
      <option value="Bangabandhu Sheikh Mujibur Rahman Science and Technology University">Bangabandhu Sheikh Mujibur Rahman Science and Technology University</option>
      <option value="Green University of Bangladesh">Green University of Bangladesh</option>
      <option value="Canadian University of Bangladesh">Canadian University of Bangladesh</option>
      <option value="Jashore University of Science and Technology">Jashore University of Science and Technology</option>
      <option value="ASA University Bangladesh">ASA University Bangladesh</option>
      <option value="Sher-e-Bangla Agricultural University">Sher-e-Bangla Agricultural University</option>
      <option value="Hajee Mohammad Danesh Science and Technology University">Hajee Mohammad Danesh Science and Technology University</option>
      <option value="Primeasia University">Primeasia University</option>
      <option value="Sylhet Agricultural University">Sylhet Agricultural University</option>
      <option value="Dhaka International University">Dhaka International University</option>
      <option value="Patuakhali Science and Technology University">Patuakhali Science and Technology University</option>
      <option value="BGMEA University of Fashion and Technology">BGMEA University of Fashion and Technology</option>
      <option value="Mawlana Bhashani Science and Technology University">Mawlana Bhashani Science and Technology University</option>
      <option value="Comilla University">Comilla University</option>
      <option value="University of Science and Technology Chittagong">University of Science and Technology Chittagong</option>
      <option value="Sonargaon University">Sonargaon University</option>
      <option value="Metropolitan University">Metropolitan University</option>
      <option value="State University of Bangladesh">State University of Bangladesh</option>
      <option value="Northern University of Bangladesh">Northern University of Bangladesh</option>
      <option value="Eastern University, Bangladesh">Eastern University, Bangladesh</option>
      <option value="World University of Bangladesh">World University of Bangladesh</option>
      <option value="Manarat International University">Manarat International University</option>
      <option value="Begum Rokeya University, Rangpur">Begum Rokeya University, Rangpur</option>
      <option value="University of Information Technology and Sciences">University of Information Technology and Sciences</option>
      <option value="Asian University of Bangladesh">Asian University of Bangladesh</option>
      <option value="Leading University">Leading University</option>
      <option value="Bangabandhu Sheikh Mujibur Rahman Maritime University">Bangabandhu Sheikh Mujibur Rahman Maritime University</option>
      <option value="Jatiya Kabi Kazi Nazrul Islam University">Jatiya Kabi Kazi Nazrul Islam University</option>
      <option value="Notre Dame University Bangladesh">Notre Dame University Bangladesh</option>
      <option value="Shanto Mariam University of Creative Technology">Shanto Mariam University of Creative Technology</option>
      <option value="East Delta University">East Delta University</option>
      <option value="Gono Bishwabidyalay">Gono Bishwabidyalay</option>
      <option value="Islamic Arabic University">Islamic Arabic University</option>
      <option value="Presidency University, Bangladesh">Presidency University, Bangladesh</option>
      <option value="Pabna Science and Technology University">Pabna Science and Technology University</option>
      <option value="Prime University">Prime University</option>
      <option value="City University">City University</option>
      <option value="First Capital University of Bangladesh">First Capital University of Bangladesh</option>
      <option value="University of Development Alternative">University of Development Alternative</option>
      <option value="University of Global Village">University of Global Village</option>
      <option value="Sheikh Fazilatunnesa Mujib University">Sheikh Fazilatunnesa Mujib University</option>
      <option value="Bangladesh University">Bangladesh University</option>
      <option value="Atish Dipankar University of Science and Technology">Atish Dipankar University of Science and Technology</option>
      <option value="Uttara University">Uttara University</option>
      <option value="University of South Asia, Bangladesh">University of South Asia, Bangladesh</option>
      <option value="Chittagong Independent University">Chittagong Independent University</option>
      <option value="Chittagong Medical University">Chittagong Medical University</option>
      <option value="Royal University of Dhaka">Royal University of Dhaka</option>
      <option value="Premier University">Premier University</option>
      <option value="Port City International University">Port City International University</option>
      <option value="Varendra University">Varendra University</option>
      <option value="Southern University Bangladesh">Southern University Bangladesh</option>
      <option value="European University of Bangladesh">European University of Bangladesh</option>
      <option value="Sylhet International University">Sylhet International University</option>
      <option value="Queens University">Queens University</option>
      <option value="IBAIS University">IBAIS University</option>
      <option value="ZNRF University of Management Sciences">ZNRF University of Management Sciences</option>
      <option value="Sheikh Hasina University">Sheikh Hasina University</option>
      <option value="North East University Bangladesh">North East University Bangladesh</option>
      <option value="Fareast International University">Fareast International University</option>
      <option value="The Millenium University">The Millenium University</option>
      <option value="The People's University of Bangladesh">The People's University of Bangladesh</option>
      <option value="Victoria University of Bangladesh">Victoria University of Bangladesh</option>
      <option value="Begum Gulchemonara Trust University">Begum Gulchemonara Trust University</option>
      <option value="Rangamati Science and Technology University">Rangamati Science and Technology University</option>
      <option value="The International University of Scholars">The International University of Scholars</option>
      <option value="Bangamata Sheikh Fojilatunnesa Mujib Science and Technology University">Bangamata Sheikh Fojilatunnesa Mujib Science and Technology University</option>
      <option value="University of Creative Technology Chittagong">University of Creative Technology Chittagong</option>
      <option value="Rabindra University, Bangladesh">Rabindra University, Bangladesh</option>
      <option value="Anwer Khan Modern University">Anwer Khan Modern University</option>
      <option value="Rajshahi Science and Technology University">Rajshahi Science and Technology University</option>
      <option value="North Western University">North Western University</option>
      <option value="Bangladesh Islami University">Bangladesh Islami University</option>
      <option value="Rajshahi Medical University">Rajshahi Medical University</option>
      <option value="Hamdard University of Bangladesh">Hamdard University of Bangladesh</option>
      <option value="German University Bangladesh">German University Bangladesh</option>
      <option value="Northern University of Business and Technology, Khulna">Northern University of Business and Technology, Khulna</option>
      <option value="Central Women's University">Central Women's University</option>
      <option value="N.P.I. University of Bangladesh">N.P.I. University of Bangladesh</option>
      <option value="Feni University">Feni University</option>
      <option value="Rabindra Maitree University">Rabindra Maitree University</option>
      <option value="Ranada Prasad Shaha University">Ranada Prasad Shaha University</option>
      <option value="Ishakha International University, Bangladesh">Ishakha International University, Bangladesh</option>
      <option value="Khulna Agricultural University">Khulna Agricultural University</option>
      <option value="North Bengal International University">North Bengal International University</option>
      <option value="Pundra University of Science and Technology">Pundra University of Science and Technology</option>
      <option value="Bangladesh University of Health Sciences">Bangladesh University of Health Sciences</option>
      <option value="Khwaja Yunus Ali University">Khwaja Yunus Ali University</option>
      <option value="International Standard University">International Standard University</option>
      <option value="Bandarban University">Bandarban University</option>
      <option value="Global University Bangladesh">Global University Bangladesh</option>
      <option value="Sylhet Medical University">Sylhet Medical University</option>
      <option value="CCN University of Science and Technology">CCN University of Science and Technology</option>
      <option value="Times University of Bangladesh">Times University of Bangladesh</option>
      <option value="Britannia University">Britannia University</option>
      <option value="Cox's Bazar International University">Cox's Bazar International University</option>
      <option value="Z.H. Sikder University of Science and Technology">Z.H. Sikder University of Science and Technology</option>
      <option value="Central University of Science and Technology">Central University of Science and Technology</option>
      <option value="Exim Bank Agricultural University of Bangladesh">Exim Bank Agricultural University of Bangladesh</option>
    </select>
  </div> */}
  
  <div>
    <div className="translate-y-3 ml-5 bg-white w-56 flex justify-center items-center textMain">
      More about your requirement
    </div>
    <input
      type="text"
      name="req"
      placeholder={postData.req}
      className="input border-2 border-orange-500 h-[60px] input-warning w-full "
      onChange={handleInputChange}
    />
  </div>
      </div>
      <div className='flex mt-10 mx-5'>
      <button
onClick={handleSubmit}
className='w-32 h-10 flex justify-center items-center bg-orange-500 text-white rounded my-5'
>
{isUploading ? <LoaderSmall /> : 'Upload'}
</button>

  
      </div>
      </div>
    );
};

export default AdminLeadsDetails;